import { forwardRef } from "react";
import { Button, Input, Tooltip } from "@mui/material";
import { tss } from "tss-react/mui";
import {  useSelector } from 'react-redux';
import { VisibilityOff, CenterFocusStrong, RemoveCircle } from "@mui/icons-material";
import { LayersDuplicate } from "assets/images/index";
import LayerOpacity from "assets/images/ic_opacity.svg";
import commonStyles from "styles/common";

const useStyles = tss.create(({theme}) => ({
    borderNone: {
        border: "none",
        minWidth: 16,
        width: 52,
        color: theme.palette.text.secondary,
        "&:hover  svg": {
            color: theme.palette.primary.main,
            fill: theme.palette.primary.main,
            "& path": {
                stroke: theme.palette.primary.main,
            }
        },
    },
    disabled: {
        opacity: 0.25,
    },
    shaded: {
        color: theme.palette.text.secondary
    },
    opacitySection: {
         borderLeft: `solid 1px ${theme.palette.divider}`,
        display: "inline-block",
        paddingLeft: 15,
    },
    opacityInput: {
        "& input": {
            width: 53,
            height: 15,
            outline: 0,
            border: 0,
            borderBottom: "solid 1px #adbbd3",
            textAlign: "center",
            fontSize: 14,
            letterSpacing: 0,
            lineHeight: "16px",
            backgroundColor: "transparent",
        },
    },
}));

type IProps = {
    isVisible: boolean;
    opacity: number;
    toggleVisibility?: () => void;
    setTransparency?: (evt: any) => void;
    zoomToLayer?: () => void;
    confirmDelete?: () => void;
    className?: any;
    style?: any;
};

const Toolbar = forwardRef((props: IProps, ref: any) => {
    const { classes } = useStyles();
    const { classes: common } = commonStyles();
    const { isVisible, opacity, toggleVisibility, setTransparency, zoomToLayer, confirmDelete, className, style } =
        props;
    const storeAuthData = useSelector((state: any) => state.auth);
    const { isDefaultProject = false } = storeAuthData;

    return (
        <div 
            className={className} 
            style={{
                ...style,
                backgroundColor: 'none'
            }}
        >
            <Tooltip title="Duplicate" placement="bottom" arrow>
                <Button size="small" className={classes.borderNone} disabled={true}>
                    <LayersDuplicate className={common.disabled} />
                </Button>
            </Tooltip>
            <Tooltip title="Show/Hide" placement="bottom" arrow>
                <Button
                    size="small"
                    className={isVisible ? classes.borderNone : [classes.borderNone, classes.disabled].join(" ")}
                    onClick={toggleVisibility}
                >
                    <VisibilityOff className={classes.shaded} />
                </Button>
            </Tooltip>
            <Tooltip title="Zoom to layer" placement="bottom" arrow>
                <Button 
                    className={classes.borderNone}
                    onClick={zoomToLayer} 
                    disabled={!zoomToLayer}
                >
                    <CenterFocusStrong className={!zoomToLayer ? common.disableEventsNoShades : classes.shaded} />
                </Button>
            </Tooltip>
            <Tooltip title="Delete" placement="bottom" arrow>
                <Button className={classes.borderNone} onClick={confirmDelete} disabled={isDefaultProject || !confirmDelete}>
                    <RemoveCircle className={isDefaultProject || !confirmDelete ? common.disableEventsNoShades : classes.shaded} />
                </Button>
            </Tooltip>
            <div
                className={classes.opacitySection}
            >
                <img src={LayerOpacity} alt="Layer opacity" style={{ position: "relative", top: 4, right: 6 }} />
                <Input
                    type="number"
                    id="layer_properties_opacity"
                    value={Math.round(opacity)}
                    className={classes.opacityInput}
                    inputProps={{ min: 0, max: 100, step: 1 }}
                    onChange={setTransparency}
                />
            </div>
        </div>
    );
});
export default Toolbar;
